(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rebuy-cart-behaviors"] && !Shopify.designMode) return;
  try {
    const GIFT_SUBSCRIPTION_PRODUCT_TYPE = "Gift Subscription";
const GIFT_SUBSCRIPTION_DUPLICATE_MESSAGE =
  "Only one gift subscription can be purchased per order.";
const GIFT_SUBSCRIPTION_EXCLUSIVE_MESSAGE =
  "A gift subscription is checked out on its own, so the other items were removed from your cart.";
const GIFT_SUBSCRIPTION_NOTICE_DURATION = 6000;
// Retries for the page-load pass only. Rebuy's bundle loads async and may not
// have booted by the +300ms mark, and that pass is what seeds knownGiftSubKey —
// without it a later duplicate add can't tell which line was already in the
// cart and falls back to cart ordering.
const GIFT_SUBSCRIPTION_INIT_RETRIES = 10;

// Line key of the gift subscription already in the cart, so the pre-existing
// line is the one kept when another gift subscription gets added
let knownGiftSubKey = null;

// Line keys the current exclusivity sweep is removing, so the property
// enrichment pass — which runs later off the same rebuy:cart.change — skips
// them. Repopulated by every sweep, so a key never outlives its cart change.
let pendingRemovalKeys = new Set();

/**
 * Limits quantity to 1 for products tagged with "Max1"
 * Runs after cart changes with 300ms delay for Rebuy to initialize
 */
function limitItemQuantities() {
  setTimeout(() => {
    if (!window.Rebuy?.SmartCart) {
      return;
    }

    const cartItems = window.Rebuy.SmartCart.items();

    cartItems.forEach((item) => {
      if (item.product?.tags.includes("Max1") && item.quantity > 1) {
        window.Rebuy.Cart.setItemQuantity(item, 1);
      }
    });
  }, 300);
}

/**
 * Enforces that a gift subscription is the only thing in the cart
 * Products are identified by the "Gift Subscription" product type. Whenever one
 * is present, every other line — extra gift subscriptions and ordinary products
 * alike — is removed and a toast notice shown. Expressing the rule as a single
 * invariant ("a gift subscription cart holds exactly that one line") means the
 * sweep doesn't need to know which side was added: adding a gift sub to a full
 * cart and adding a product to a gift sub cart both converge here.
 * Runs after cart changes with 300ms delay for Rebuy to initialize
 *
 * @param {number} retriesLeft - Times to re-check if Rebuy isn't ready yet
 */
function enforceGiftSubscriptionExclusivity(retriesLeft = 0) {
  setTimeout(() => {
    if (!window.Rebuy?.SmartCart) {
      if (retriesLeft > 0) {
        enforceGiftSubscriptionExclusivity(retriesLeft - 1);
      }
      return;
    }

    const cartItems = window.Rebuy.SmartCart.items();
    const giftSubItems = cartItems.filter(
      (item) => item.product_type === GIFT_SUBSCRIPTION_PRODUCT_TYPE
    );

    pendingRemovalKeys = new Set();

    if (giftSubItems.length === 0) {
      knownGiftSubKey = null;
      return;
    }

    // Shopify orders cart lines newest-first, so when no line is known yet
    // (e.g. cart was filled in another tab) the last line is the oldest
    const keptItem =
      giftSubItems.find((item) => item.key === knownGiftSubKey) ||
      giftSubItems[giftSubItems.length - 1];

    knownGiftSubKey = keptItem.key;

    // One gift subscription means one unit, not just one line. The PDP omits the
    // quantity selector and Rebuy hides in-cart quantity edits, so this only
    // catches a cart built outside those paths — but it keeps the rule from
    // depending on app config.
    if (keptItem.quantity > 1) {
      window.Rebuy.Cart.setItemQuantity(keptItem, 1);
    }

    const removedItems = cartItems.filter((item) => item.key !== keptItem.key);

    if (removedItems.length === 0) {
      return;
    }

    removedItems.forEach((item) => pendingRemovalKeys.add(item.key));
    removedItems.forEach(removeCartItem);

    // Every removal fires another rebuy:cart.change, so the sweep re-runs, finds
    // the cart already down to the kept line, and no-ops
    const onlyDuplicateGiftSubs = removedItems.length === giftSubItems.length - 1;
    showGiftSubscriptionNotice(
      onlyDuplicateGiftSubs
        ? GIFT_SUBSCRIPTION_DUPLICATE_MESSAGE
        : GIFT_SUBSCRIPTION_EXCLUSIVE_MESSAGE
    );
  }, 300);
}

/**
 * Removes a line item from the cart, covering both Rebuy API variants
 *
 * @param {Object} item - Cart line item object from Rebuy
 */
function removeCartItem(item) {
  if (typeof window.Rebuy.Cart.removeItem === "function") {
    window.Rebuy.Cart.removeItem(item);
  } else {
    window.Rebuy.Cart.setItemQuantity(item, 0);
  }
}

/**
 * Shows a gift subscription notice as a toast over the Smart Cart flyout,
 * auto-dismissed after 6s. Rendered on document.body because the flyout is a
 * Vue-managed subtree that drops injected elements on re-render. An existing
 * notice is reused so repeated removals refresh it rather than stacking.
 *
 * @param {string} message - Copy explaining what was removed and why
 */
function showGiftSubscriptionNotice(message) {
  let notice = document.querySelector(".rebuy-cart__gift-sub-notice");

  if (!notice) {
    notice = document.createElement("div");
    notice.className = "rebuy-cart__gift-sub-notice";
    notice.setAttribute("role", "alert");
    document.body.appendChild(notice);
  }

  notice.textContent = message;

  clearTimeout(showGiftSubscriptionNotice.dismissTimer);
  showGiftSubscriptionNotice.dismissTimer = setTimeout(() => {
    notice.remove();
  }, GIFT_SUBSCRIPTION_NOTICE_DURATION);
}

/**
 * Resets free shipping minimum to $0 when specific SKUs are in cart
 * SKUs defined in theme.liquid as free_shipping_skus array
 * Original threshold defined as free_shipping_threshold
 * Runs after cart changes with 500ms delay
 */
function resetFreeShippingMinimum() {
  setTimeout(() => {
    if (!window.Rebuy?.SmartCart) {
      return;
    }

    const items = window.Rebuy.SmartCart.items();
    let freeShipping = false;

    items.forEach((item) => {
      if (
        free_shipping_skus.includes(item.sku) &&
        window.Rebuy.SmartCart.progressBar
      ) {
        window.Rebuy.SmartCart.progressBar.tiers[0].minimum = 0;
        freeShipping = true;
      }
    });

    // Restore original threshold if qualifying items removed
    if (!freeShipping && window.Rebuy.SmartCart.progressBar) {
      window.Rebuy.SmartCart.progressBar.tiers[0].minimum = free_shipping_threshold;
    }
  }, 500);
}

/**
 * Removes duplicate selling plan options from subscription dropdowns
 * Preserves currently selected option even if duplicate
 * Runs after cart changes with 500ms delay
 */
function removeUnnecessarySellingPlans() {
  setTimeout(() => {
    if (!window.Rebuy) {
      return;
    }

    document.querySelectorAll(".rebuy-select.muted").forEach((select) => {
      const seenValues = new Set();
      let selectedOption = select.querySelector("option:checked");

      const opts = select.querySelectorAll("option");

      Array.from(opts).forEach((option) => {
        if (seenValues.has(option.value) && option !== selectedOption) {
          option.remove();
        } else {
          seenValues.add(option.value);
        }
      });

      // Restore selected option if it was removed
      if (selectedOption && !select.contains(selectedOption)) {
        select.appendChild(selectedOption);
        selectedOption.selected = true;
      }
    });
  }, 500);
}

/**
 * Enriches cart line items with custom properties for analytics and shipping
 * Properties added:
 * - _subscription: "true" if item has selling plan
 * - _selling_plan: ID of the selling plan
 * - _product_type: Product type for analytics
 * - _requires_ground_shipping: Metafield for shipping logic
 *
 * KNOWN ISSUE: Shopify discountAllocations bug
 * As of October 2024, Shopify's Cart API doesn't properly clear discountAllocations
 * when discount codes are removed. The commented code below attempts to clean up
 * _promo_type and _promo_value properties, but causes infinite loops due to the bug.
 *
 * References:
 * - https://github.com/Shopify/storefront-api-feedback/discussions/22
 * - https://community.shopify.com/t/discountallocations-not-removed-correctly-from-storefront-api/174891
 *
 * Status: Under investigation by Shopify (since Jan 2023, partial fixes in Aug 2024)
 * TODO: Re-test this workaround in Q1 2025 after Shopify resolves edge cases
 *
 * @param {Object} item - Cart line item object from Rebuy
 * @returns {null}
 */
function itemEnrichProperties(item) {
  if (!item) return null;
  // Enriching a line the sweep is removing is at best discarded with the line,
  // at worst it wins the race and invalidates the key the removal is addressed
  // by, leaving the duplicate in the cart until the next sweep.
  if (pendingRemovalKeys.has(item.key)) return null;

  const newProperties = Object.assign({}, item.properties);
  let propertyChanged = false;

  // _subscription line item property
  if (item.selling_plan_allocation) {
    if (newProperties._subscription !== "true") {
      newProperties._subscription = "true";
      propertyChanged = true;
    }
  } else if ("_subscription" in newProperties) {
    delete newProperties["_subscription"];
    propertyChanged = true;
  }

  // _selling_plan line item property
  const sellingPlanId =
    item.selling_plan_allocation?.selling_plan?.id?.toString();
  if (sellingPlanId) {
    if (newProperties._selling_plan !== sellingPlanId) {
      newProperties._selling_plan = sellingPlanId;
      propertyChanged = true;
    }
  } else if ("_selling_plan" in newProperties) {
    delete newProperties["_selling_plan"];
    propertyChanged = true;
  }

  // _product_type line item property
  if (item.product_type) {
    if (newProperties._product_type !== item.product_type) {
      newProperties._product_type = item.product_type;
      propertyChanged = true;
    }
  } else if ("_product_type" in item.properties) {
    delete newProperties["_product_type"];
    propertyChanged = true;
  }

  // _requires_ground_shipping line item property
  if (newProperties._requires_ground_shipping !== item?.product?.metafields?.custom?.requires_ground_shipping) {
    newProperties._requires_ground_shipping =
      item?.product?.metafields?.custom?.requires_ground_shipping;
    propertyChanged = true;
  }

  // Only update if properties actually changed (prevents infinite loops)
  if (propertyChanged && window.Rebuy?.Cart) {
    // Addressed by line item key, not line number: a positional index captured
    // here can point at a different line once the exclusivity sweep's removals
    // land, and a properties write replaces the line's whole hash (SC-736495).
    window.Rebuy.Cart.changeItem({
      id: item.key,
      properties: newProperties,
      quantity: item.quantity || 1,
    });
  }
}

/**
 * Applies property enrichment to all cart items
 * Runs with 500ms delay after cart changes
 */
function cartLineItemsEnrichProperties() {
  setTimeout(() => {
    if (!window.Rebuy?.Cart) {
      return;
    }
    for (const item of window.Rebuy.Cart.items()) {
      itemEnrichProperties(item);
    }
  }, 500);
}

/**
 * Adds _base_variant_id property when products are added to cart
 * Used for tracking variant swaps (e.g., size/color changes)
 * Base variant ID comes from cart.base_variant_id metafield
 *
 * @param {Event} event - rebuy.beforeAdd event
 */
function updateBaseVariantIdProperty(event) {
  const selectedVariant = event.detail.product.selected_variant;
  if (selectedVariant?.metafields?.cart?.base_variant_id) {
    const baseVariantId = selectedVariant.metafields.cart.base_variant_id
      .split("/")
      .pop();
    event.detail.product.properties._base_variant_id = baseVariantId;
  }
}

// Initialize on page load
resetFreeShippingMinimum();
removeUnnecessarySellingPlans();
enforceGiftSubscriptionExclusivity(GIFT_SUBSCRIPTION_INIT_RETRIES);

// Cart change event listener
document.addEventListener("rebuy:cart.change", function () {
  limitItemQuantities();
  enforceGiftSubscriptionExclusivity();
  resetFreeShippingMinimum();
  removeUnnecessarySellingPlans();
  cartLineItemsEnrichProperties();
});

// Before add to cart event listener
document.addEventListener("rebuy.beforeAdd", function (event) {
  updateBaseVariantIdProperty(event);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rebuy-widget-enhancements"] && !Shopify.designMode) return;
  try {
    document.addEventListener("rebuy.ready", function () {
  const rebuyWidgets = document.querySelectorAll('.widget-type-product .rebuy-widget-content');
  const subscriberType = window.subscriberType;

  if (rebuyWidgets.length > 0) {
    rebuyWidgets.forEach((widget) => {
      // Only process widgets that haven't been enhanced yet
      if (!(widget.querySelector('.widget-top-container'))) {
        const rebuyProductBlocks = widget.querySelectorAll('.rebuy-product-block');
        const widgetDescription = widget.querySelector('.description');
        const widgetVisibilityElement = widget.closest('.widget-type-product');
        const widgetTitle = widget.querySelector('.primary-title');
        const parentSection = widget.closest('.section');

        // Create layout structure
        const widgetTopContainer = document.createElement('div');
        const widgetButtonContainer = document.createElement('div');

        widgetTopContainer.className = 'widget-top-container';
        widgetButtonContainer.className = 'widget-button-container';
        widget.insertBefore(widgetTopContainer, widget.firstChild);
        widgetTopContainer.appendChild(widgetTitle);
        widgetTopContainer.appendChild(widgetButtonContainer);

        // Adjust section padding if widget is hidden
        if (widgetVisibilityElement && widgetVisibilityElement.classList.contains('is-hidden')) {
          parentSection.style.paddingTop = '0';
        }

        // Add description to top container if it exists
        if (widgetDescription) {
          widgetTopContainer.appendChild(widgetDescription);
        }

        // Hide navigation for small product sets (< 5 items)
        if (rebuyProductBlocks.length < 5) {
          if (widgetDescription) {
            widgetDescription.style.display = 'block';
            widgetDescription.classList.add('no-nav-buttons');
          }
          if (widgetButtonContainer) {
            widgetButtonContainer.style.display = 'none';
          }
        }

        // Enhance product blocks
        rebuyProductBlocks.forEach((block, index) => {
          const badgeList = block.querySelector(".product-card__badge-list");

          // Skip if badges already exist from metafields
          if (badgeList) {
            return;
          }

          // Extract product information
          let productName = '';
          const blockProductInfo = block.querySelector('.rebuy-product-info a');
          if (blockProductInfo) {
            productName = blockProductInfo.textContent.trim();
          }

          let productId = '';
          const productIdClass = Array.from(block.classList).find(className => className.startsWith('product-id-'));
          if (productIdClass) {
            productId = productIdClass.split('-').pop();
          }

          // Add "On Sale" badge if product has compare-at price
          const compareAtPrice = block.querySelector(".compare-at");
          if (compareAtPrice) {
            const badgeListDiv = document.createElement('div');
            badgeListDiv.className = 'product-card__badge-list';

            const badge = document.createElement('span');
            badge.className = 'badge badge--on-sale';
            badge.textContent = 'On Sale';

            badgeListDiv.appendChild(badge);
            block.appendChild(badgeListDiv);
          }

          // Track recommendation clicks
          block.addEventListener("click", function (event) {
            Shopify.analytics.publish('rudderstack_track', {
              eventName: 'Recommendation Click',
              eventData: {
                "widgetTitle": widgetTitle?.textContent?.trim(),
                "widgetId": widget?.closest('[data-rebuy-id]')?.getAttribute('data-rebuy-id'),
                "productName": productName,
                "productId": productId,
                "productPosition": index + 1,
                "path": window.location.pathname,
                "subscriberType": subscriberType,
                "subscriberExclusive": block.classList.contains('subscriber-exclusive')
              }
            });
          });
        });
      }

      // Monitor for Flickity navigation buttons (loaded asynchronously)
      const observer = new MutationObserver(() => {
        const widgetNextButton = widget.querySelector('.flickity-button.next');
        const widgetPreviousButton = widget.querySelector('.flickity-button.previous');
        const widgetButtonContainer = widget.querySelector('.widget-button-container');

        if (widgetNextButton && widgetPreviousButton && widgetButtonContainer) {
          // Reposition navigation buttons to custom container
          widgetButtonContainer.appendChild(widgetPreviousButton);
          widgetButtonContainer.appendChild(widgetNextButton);
          observer.disconnect(); // Stop observing once buttons are found and moved
        }
      });

      observer.observe(widget, { childList: true, subtree: true });
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
